import React, { Component } from 'react';
import Contact from './buttons/contact';
import {
  getDwelling,
  dwellingIsLoaded,
  GET_CONTACT_DETAIL_SUCCESS
} from '../redux/modules/dwelling';
import { Grid, Alert, Carousel } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import { Link } from 'react-router';
import EmailSignup from '../common/email-signup';
import { slugify } from '../utils/format';
import ContactTable from './contact-details.component';
import IconList from '../common/icon/icon-list';
import DocumentMeta from 'react-document-meta';
import Unavailable from './buttons/unavailable';
import { imageUrl } from '../utils/image-url';
import LoadingSpinner from '../common/loading-spinner';
import ErrorMessage from '../common/error-message';
import { SETMAIL_SUCCESS } from '../redux/modules/auth';
import VerifyEmail from '../common/verify-email';
// import subscriptionTiming from '../utils/subscription-timing';
import shallowEqual from '../utils/shallow-equal';
import { browserHistory } from 'react-router';
import {
  userFlowNext,
  authLocal,
  getSubscriptionPath
} from '../profile/redirection';
import { setStatusCode } from 'app/redux/modules/app';

const BUTTON_TOP = 'ctaTop';
const BUTTON_BOTTOM = 'ctaBottom';

const { Map, Marker, TileLayer } = __CLIENT__ ? require('react-leaflet') : {};

@i18n
class Dwelling extends Component {
  static fetchData({ getState, dispatch, params, reload }) {
    const promise = Promise.resolve().then(async () => {
      const currentState = getState();
      if (params.id) {
        if (reload || !dwellingIsLoaded(currentState, params.id)) {
          const { payload } = await dispatch(
            getDwelling(params.id, {
              subscriber: getState().subscriptions.subscriber
            })
          );

          if (payload.status === 0) {
            await dispatch(setStatusCode(404));
          }
        }
      }
    });
    return promise;
  }

  constructor(props) {
    super(props);
    const slug =
      props.dwelling && props.dwelling.detail
        ? slugify(props.dwelling.detail.location.city)
        : '';
    const city = props.cities.filter(item => item.slug === slug)[0] || null;

    this.state = {
      area: city || props.city || { label: false },
      notAvailable:
        props.dwelling &&
        props.dwelling.detail &&
        props.dwelling.detail.deletedAt,
      missingUserDetails: false,
      buttonLocation: null,
      error: false,
      index: 0,
      direction: null,
      showMap: false
    };

    if (props.location.query.user) {
      const { user, utm_source, ...query } = props.location.query || {};

      if (user && utm_source) {
        this.props.notificationLog({
          user: user,
          source: utm_source,
          type: query['amp;utm_medium'] || query['utm_medium'],
          dwellingId: props.dwelling.detail.dwellingId
        });
      }
    }
  }

  componentDidMount() {
    this.updateBoligagent(this.props);
    this.getAgentAuto(this.props);
    this.setState({ showMap: true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      if (!shallowEqual(nextProps.user, this.props.user)) {
        this.updateBoligagent(nextProps);
      }
      if (nextProps.user.status) {
        this.setState({ missingUserDetails: false });
      }
    }

    this.getAgentAuto(nextProps);
  }

  getAgentAuto(props) {
    if (props.subscriber && !this.props.subscriber) {
      const { lastDwelling, detail } = props.dwelling;
      if (
        detail &&
        lastDwelling &&
        lastDwelling.dwellingId === detail.dwellingId
      ) {
        this.props.setLastDwelling(null);
        this.props.getContact(lastDwelling.dwellingId);
      }
    } else if (!props.subscriber) {
      const { lastDwelling, detail } = props.dwelling;
      if (
        detail &&
        (!lastDwelling || lastDwelling.dwellingId !== detail.dwellingId)
      ) {
        props.setLastDwelling(detail);
      }
    }
  }

  updateBoligagent(props) {
    const {
      dwelling: { detail },
      adjustBoligagent,
      user,
      current,
      aliases
    } = props;
    if (detail) {
      const area = slugify(
        aliases.get(detail.location.city) || detail.location.city
      );
      if (area) {
        adjustBoligagent({ area, detail, user, current });
      }
    }
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  };

  getAgent = buttonLocation => {
    const { dwelling, user, existingUser, subscriber, getContact } = this.props;
    const isNext = true;

    const next = userFlowNext({ user, subscriber, existingUser, isNext });
    if (next && !/^\/vis\/[a-f0-9]+/.test(next)) {
      return browserHistory.push(next);
    }

    // if (!user) {
    //   return browserHistory.push(this.getAuthPath());
    // }
    //
    // if (!subscriber) {
    //   return browserHistory.push(this.getSubscriptionPath());
    // }

    this.setState({ buttonLocation, error: false }, () => {
      // const newSubscription = subscriptionTiming.isWithinPeriod();

      // if (!user.email && !newSubscription || !user.status && !newSubscription) {
      //   return this.setState({ missingUserDetails: true });
      // }

      getContact(dwelling.detail.dwellingId)
        .then(action => {
          if (
            action.type === GET_CONTACT_DETAIL_SUCCESS &&
            buttonLocation === BUTTON_BOTTOM
          ) {
            window.scrollTo(0, 0);
          }
          return action;
        })
        .catch(err => {
          const error = err.message;
          if (error === 'HTTP_403') {
            return browserHistory.push(getSubscriptionPath({ isNext }));
          }
          if (error === 'HTTP_401') {
            return browserHistory.push(authLocal({ isNext, existingUser }));
          }
          if (error === 'HTTP_410') {
            return this.setState({ notAvailable: true });
          }
          return this.setState({ error: true });
        });
    });
  };

  emailConfirmation = event => {
    event.preventDefault();
    this.props.setMail({ email: this.props.user.email }).then(action => {
      if (action.type === SETMAIL_SUCCESS) {
        this.setState({
          confirmMail: {
            message: this.i18n('Mange tak! Der er nu afsendt en mail.')
          }
        });
        return action;
      }
      this.setState({
        confirmMail: {
          message: this.i18n(
            'Oops! Something went wrong. Please try again or reach out to our customer support.'
          )
        }
      });
      return action;
    });
  };

  feedbackMessages = () => {
    const { user } = this.props;
    const { error } = this.state;
    if (!user) {
      return null;
    }
    if (error) {
      return (
        <Alert bsStyle="danger">
          {this.i18n(
            'Oops! Something went wrong. Please try again or reach out to our customer support.'
          )}
        </Alert>
      );
    }
    if (!user.email) {
      return (
        <Alert bsStyle="warning">
          {this.i18n(
            'Din bruger har ikke en e-mail. Men du kan nemt tilmelde en e-mail. '
          )}
          <Link to="/profile">{this.i18n('Click here!')}</Link>
        </Alert>
      );
    }
    if (!user.status) {
      return <VerifyEmail />;
    }
  };

  singleImg(hash, user) {
    return user ? (
      <img src={imageUrl(hash)} />
    ) : (
      <Link
        to={authLocal({ existingUser: this.props.existingUser })}
        title={this.i18n('Log in to see images and full description')}
      >
        <img src={imageUrl(hash)} className="blur" />
      </Link>
    );
  }

  render() {
    const { user, subscriber, statusCode, contact } = this.props;
    const { detail } = this.props.dwelling || {};
    const {
      userVerified,
      buttonLocation,
      error,
      index,
      direction
    } = this.state;
    // const subscriptionPeriod = subscriptionTiming.isWithinPeriod();

    if (statusCode) {
      return (
        <Grid>
          <ErrorMessage
            text={this.i18n(
              'Oops! Something went wrong. Please try again or reach out to our customer support.'
            )}
          />
        </Grid>
      );
    }

    if (!detail || !detail.dwellingId) {
      return <LoadingSpinner />;
    }

    const {
      // dwellingId,
      headline,
      teaser,
      description,
      remarks,
      rent,
      rooms,
      size,
      pets,
      economy,
      available,
      timeframe,
      location: { street, city },
      geolocation: { lat, lng },
      images,
      status
    } = detail || {};

    const { notAvailable, area } = this.state;

    const metaTags = {
      title: `${headline}`,
      description: teaser,
      extend: true,
      auto: {
        ograph: true
      }
    };

    //const dwellingImg = <img src={ imageUrl(dwellingId) } className='img-responsive' />;

    const addButton = placing => {
      return status !== 1 || notAvailable ? (
        <Unavailable
          title={this.i18n('Dwelling is unavailable')}
          boxText={this.i18n(
            'We are very sorry - but it looks like the dwelling is no longer available.'
          )}
        />
      ) : (
        <Contact
          onClick={() => this.getAgent(placing)}
          disabled={userVerified}
          text={this.i18n('Contact landlord now')}
        />
      );
    };

    return (
      <div className="container listing">
        <DocumentMeta {...metaTags} />
        <h1>{headline}</h1>
        <div className="row">
          <div className="col-sm-6">
            <div className={`listing-image ${!user ? 'img-blur' : ''}`}>
              {images.length > 1 ? (
                <Carousel
                  activeIndex={index}
                  direction={direction}
                  onSelect={this.handleSelect}
                >
                  {images.map((hash, idx) => (
                    <Carousel.Item key={idx}>
                      {this.singleImg(hash, user)}
                    </Carousel.Item>
                  ))}
                </Carousel>
              ) : images.length === 1 ? (
                this.singleImg(images[0], user)
              ) : null}
            </div>
          </div>
          <div className="col-sm-6 pull-right">
            <div className="row">
              <div className="col-xs-12 listing-contact">
                {contact ? (
                  <ContactTable
                    contact={contact}
                    startPeriod={/*subscriptionPeriod*/ false}
                  />
                ) : (
                  addButton(BUTTON_TOP)
                )}
                {buttonLocation === BUTTON_TOP && (userVerified || error) ? (
                  <div>
                    <br />
                    {this.feedbackMessages()}
                  </div>
                ) : null}
              </div>

              <div className="col-xs-12">
                <IconList
                  data={{
                    rent,
                    rooms,
                    size,
                    pets,
                    street,
                    city,
                    ...economy,
                    available,
                    timeframe
                  }}
                  grid={3}
                  stack
                />

                {remarks ? (
                  <p style={{ padding: '0 15px' }}>
                    <strong>{this.i18n('Please note')}</strong>
                    <br />
                    {remarks}
                  </p>
                ) : null}

                <div className="card">
                  <i
                    className="fa ico ico-money"
                    style={{
                      fontSize: '3em',
                      paddingLeft: '15px',
                      display: 'block',
                      float: 'right',
                      color: 'orange'
                    }}
                  />
                  Brug for et lån til udbetalingen?{' '}
                  <a
                    href={`https://xn--indskudsln-95a.dk/`}
                    target="_blank"
                    style={{ display: 'inline-block', fontWeight: 'bold' }}
                  >
                    Læs mere eller ansøg om et lån her
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 pull-left" style={{ clear: 'left' }}>
            {lat && lng ? (
              <div
                style={{ height: 250 }}
                className="listing-map has-map"
                data-disclaimer={this.i18n(
                  'Please notice that the marker only indicates the street and not the exact location of the dwelling.'
                )}
              >
                {this.state.showMap ? (
                  <Map
                    center={[lat, lng]}
                    zoom={14}
                    style={{ width: '100%', height: '100%' }}
                  >
                    <TileLayer
                      attribution="Kort data © OpenStreetMap contributors, © DKBY.net"
                      url="https://www.dkby.net/osm_tiles/{z}/{x}/{y}.png"
                    />
                    {/* 'https://maps.tilehosting.com/styles/bright/style.json?key=IOrAk6DZGyIWzSQnCOjm' */}
                    {/* <TileLayer
                    attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>'
                    url="https://maps.tilehosting.com/styles/streets/{z}/{x}/{y}.png?key=IOrAk6DZGyIWzSQnCOjm"
                  /> */}
                    <Marker position={[lat, lng]} />
                  </Map>
                ) : null}
              </div>
            ) : null}

            {!contact && status === 1 && !notAvailable ? (
              <div className="listing-button">{addButton(BUTTON_BOTTOM)}</div>
            ) : (
              <div />
            )}
            {buttonLocation === BUTTON_BOTTOM && (userVerified || error)
              ? this.feedbackMessages()
              : null}

            <p
              style={{ marginTop: '5px' }}
              dangerouslySetInnerHTML={{
                __html: !subscriber ? teaser : description
              }}
            />

            {user ? null : (
              <div className="alert alert-danger" role="alert">
                <strong>
                  {this.i18n('Sorry!')}
                  &nbsp;
                </strong>
                {this.i18n(
                  'Description and images are reserved for our registered tenants.'
                )}
                <br />
                <Link to="/signup" className="alert-link">
                  {this.i18n('Click here to register')}
                </Link>
                {this.i18n(' or ')}
                <Link to="/login" className="alert-link">
                  {this.i18n('Login')}
                </Link>{' '}
                {this.i18n('to get full access.')}
              </div>
            )}
          </div>
        </div>
        <EmailSignup area={area} />
        {city && (
          <p>
            Er du husvild og søger akut bolig i {city}? Surf løs på vores
            boligportal og find bolig nu, eller tilmeld dig vores BoligAgent
            under afsnittet: 'min lejebolig' på din profilside, hvor du kan
            angive dine boligønsker i {city}, som lejlighed, hus, rækkehus,
            værelse eller om du vil finde en roommate. Herefter får du e-mails
            hver gang der kommer nye ledige boliger til leje her på boligsiden
            Boligninja.dk indtil du afmelder dig.
          </p>
        )}
        <p
          className=""
          style={{ marginTop: '2em', fontSize: '0.9em', color: '#444' }}
        >
          Oplysninger på Boligninja.dk er vejledende. Boligninja.dk tager
          forbehold for forkerte samt ændrede oplysninger. Oplysninger kan være
          indsamlet automatisk med risiko for fejl opstået under indsamling der
          kan resultere i forkerte oplysninger. Du bør derfor kontrollere alle
          oplysninger og få bekræftet disse af udlejeren. Det er udlejeren der
          er kilden for det gengivede oplysninger, herunder lejemålets data,
          beskrivelser og billeder.
        </p>
      </div>
    );
  }
}

export default Dwelling;
